import React from 'react';
import { Button } from 'primereact/button';

import { handleRedirection } from 'utils/utils';
import { generateFullName } from 'utils/generateFullNameUtils';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function CreateTimeline() {
  const { caseDetails, files, isCaseFileManager } = useFileManagerContext();
  const history = useHistory();

  const buildCaseData = (timelineFolder) => {
    const isLead = caseDetails?.is_lead;

    const baseData = isLead
      ? { main_client_name: generateFullName(caseDetails?.main_client?.[0]) }
      : { case_name: caseDetails?.case_description?.case_name };

    const timelineData = timelineFolder
      ? {
          timelineFolder: {
            folderName: timelineFolder.display_name,
            object_id: timelineFolder.object_id,
          },
        }
      : {};

    return { ...baseData, ...timelineData };
  };

  const handleCreateTimeline = () => {
    const caseId = caseDetails?.case_id;
    if (!caseId) return;

    const timelineFolder = files?.find(({ display_name }) => display_name === 'Timeline');

    const caseDataToPass = buildCaseData(timelineFolder);

    if (Object.keys(caseDataToPass).length > 0) {
      localStorage.setItem('caseData', JSON.stringify(caseDataToPass));
    }

    const basePath = isCaseFileManager ? 'cases' : 'leads';
    const url = `/timeline/${basePath}/${caseId}`;

    handleRedirection(history, url, caseDataToPass);
  };

  return <Button label="Create Timeline" className="p-button-primary outline text-nowrap" onClick={handleCreateTimeline} />;
}

export default CreateTimeline;
